module.exports = __webpack_public_path__ + "img/tasnatea_banner.a2a807e6.jpg";